module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"checkIn":"Check Out","checkOut":"Check In"},"sl":{"checkIn":"Prihod","checkOut":"Odhod"}}')
  delete Component.options._Ctor
}
